import { render, staticRenderFns } from "./confirmation-certificate.vue?vue&type=template&id=40332e54&scoped=true&lang=pug"
import script from "./confirmation-certificate.vue?vue&type=script&lang=ts"
export * from "./confirmation-certificate.vue?vue&type=script&lang=ts"
import style0 from "./confirmation-certificate.vue?vue&type=style&index=0&id=40332e54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40332e54",
  null
  
)

export default component.exports